class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.addNostoSingleProductToCart();
    this.addProductwithOptionNosto();

     this.colorMap = {
      "Afterglow":  "#f3e6c9",
      "Aubergine":  "#483338",
      "Beige":  "#d2c0c0",
      "Beige-Camel":  "/cdn/shop/files/beige-and-camel.png?v=1738697923&width=100",
      "Bermuda Blue":  "#35608f",
      "Black":  "#000000",
      "Black/Grey":  "/cdn/shop/files/black-and-grey.png?v=1737742085&width=100",
      "Black/Ivory":  "/cdn/shop/files/Black_Ivory.png?v=1742927254&width=100",
      "Black/Red":  "/cdn/shop/files/Red_Black_Swatch.jpg?v=1747328376&width=100",
      "Black/White":  "/cdn/shop/files/black-and-white.png?v=1737742085&width=100",
      "Blue":  "#346b99",
      "White/Blue":  "/cdn/shop/files/Darkness-Swatch-Blue-White-v2.jpg?v=1744327631&width=100",
      "Boulder":  "#c6bbb0",
      "Brown-Black":  "/cdn/shop/files/brown-and-black.png?v=1738697892&width=100",
      "Brown-Plaid":  "/cdn/shop/files/Brown-Plaid.jpg?v=1738697871&width=100",
      "Celadon":  "#afc5b8",
      "Charcoal":  "#626876",
      "Checker-Plaid":  "/cdn/shop/files/Checker-Plaid.jpg?v=1738697838&width=100",
      "Ciel":  "#c6e3f5",
      "Cream":  "#efddcf",
      "Dark Azure":  "#6fd8d4",
      "Dark Grey":  "#9f9c9c",
      "Dark Navy":  "#141869",
      "Darkness":  "/cdn/shop/files/black-and-white.png?v=1737742085&width=100",
      "Desert":  "#e4dbc4",
      "Freedom Green":  "#85afb3",
      "Freedom Grey":  "#d2d4e4",
      "Freedom Tan":  "#f5cebd",
      "Golden":  "#ba906a",
      "Grey/Black":  "/cdn/shop/files/grey-and-black.png?v=1739567282&width=100",
      "Green":  "#239c1a",
      "Green/Orange":  "/cdn/shop/files/Green_Orange.png?v=1741889351&width=100",
      "Grey":  "#777b7f",
      "Grey/Blue":  "/cdn/shop/files/Grey-Blue.jpg?v=1745342819&width=100",
      "Heather Grey":  "/cdn/shop/files/Heather_Gray.png?v=1741890390&width=100",
      "Hope Blue":  "#4c91c5",
      "Hunter Green":  "#434932",
      "Yellow":"#ecff00",
      "In Bloom":  "#f8d9c7",
      "Ivory":  "#fffff0",
      "Khaki":  "#e8d1b1",
      "Light Azure":  "#7bc6c7",
      "Light Blue":  "#b6daf7",
      "Light Grey":  "#bac1cc",
      "Light Pink":  "#fadee5",
      "Marigold":  "#f8b432",
      "Midnight Blue":  "#192f5c",
      "Military Green":  "#676e46",
      "Mini-Check":  "/cdn/shop/files/mini-check.png?v=1738697610&width=100",
      "Mocha":  "#3b342f",
      "Multi-Color":  "#f50fe7",
      "Natural":  "#f3e6c9",
      "Navy":  "#00497c",
      "Navy/Orange":  "/cdn/shop/files/Navy_Orange.png?v=1741889558&width=100",
      "Navy/White":  "/cdn/shop/files/navy-and-white.png?v=1737742085&width=100",
      "Neon Pink":  "#f05096",
      "Odg-Black":  "/cdn/shop/files/odg-and-black.png?v=1738697749&width=100",
      "Ombre Plaid":  "/cdn/shop/files/Ombre-Plaid.jpg?v=1738697698&width=100",
      "Orange":  "#c67556",
      "Orchid":  "#94368e",
      "Paratrooper Blue":  "#00497c",
      "Peacoat/Rust":  "/cdn/shop/files/Peacoat_Rust_d2a54334-0600-4adf-95a6-f61b45a94f0b.png?v=1741892766&width=100",
      "Pink":  "#f0abbe",
      "Purple":  "#786c92",
      "Red":  "#ff0000",
      "Red/Black":  "/cdn/shop/files/Red_Black_Swatch.jpg?v=1747328376&width=100",
      "Red/White/Blue":  "/cdn/shop/files/Stars-and-Stripes-Swatch.jpg?v=1747764703&width=100",
      "Rose Gold":  "#f0dbe2",
      "Rust":  "#851f28",
      "Saguaro Green":  "#accabc",
      "Stone Fruit":  "#d3a081",
      "Sunshine":  "#f8dd6c",
      "Tan":  "#bfad80",
      "Taupe":  "#a99a93",
      "Warm Sand":  "#c5ae91",
      "White":  "#ffffff",
      "White/Black":  "/cdn/shop/files/white-and-black.png?v=1737742085&width=100",
      "White/Blazer Navy":  "/cdn/shop/files/White_Blazer_Navy.png?v=1741890979&width=100",
      "White/Grey":  "/cdn/shop/files/white-and-grey.png?v=1737742085&width=100",
      "White/Navy":  "/cdn/shop/files/White_Navy.png?v=1741891409&width=100",
      "White/Pink":  "/cdn/shop/files/White_Pink_Swatch.jpg?v=1747328010&width=100",
      "White/Red":  "/cdn/shop/files/Darkness-Swatch-Red-Whire-v2.jpg?v=1744327642&width=100",
      "White/Slit Green":  "/cdn/shop/files/White_Slit_Green.png?v=1741891517&width=100",
      "White/Toast":  ""
    }
    
    this.bindEventWithAccordion();
    this.onNostoInjected();
    this.matchHeightAutoComplete();
    this.matchHeightAutocompleteRec();
  }

  matchHeightPerRow(selector) {
    const items = document.querySelectorAll(selector);
    if (!items.length) return;
  
    // Reset heights first
    items.forEach(el => (el.style.height = "auto"));
  
    // If only one item per row (stacked), skip
    if (items.length <= 1) return;
  
    // Group by row using offsetTop
    const rows = {};
    items.forEach(el => {
      const top = el.offsetTop;
      if (!rows[top]) rows[top] = [];
      rows[top].push(el);
    });
  
    // For each row, set equal height
    Object.values(rows).forEach(rowEls => {
      if (rowEls.length > 1) { // only apply if >1 item in row
        let max = 0;
        rowEls.forEach(el => {
          max = Math.max(max, el.offsetHeight);
        });
        rowEls.forEach(el => {
          el.style.height = max + "px";
        });
      }
    });
  }

  matchHeightAutocompleteRec(){
    const item = this;
    if(document.querySelectorAll('.header__search .pxg-header-search .desktop-button').length){
      console.log(document.querySelectorAll('.header__search .pxg-header-search .desktop-button').length,'testinngg')
      const searchEls = document.querySelectorAll('.header__search .pxg-header-search .desktop-button');
      if(searchEls.length){
          searchEls.forEach((btn) => {
            btn.addEventListener("click", function () {
              setTimeout(()=>{
                item.handleMatchHeight('.search-rec-items')
              },200)
              console.log("clicked", btn);
            });
          });
      }
    }
  }
 
// Run on load and resize
  handleMatchHeight(selector) {
    // Only run on mobile/tablet (<= 768px for example)
    this.matchHeightPerRow(selector); // adjust selector
  }
 
  onNostoInjected() {    
   const observer = new MutationObserver(() => {
      const els = document.querySelectorAll('[data-nosto-element="search"]');
      els.forEach(el => { 
        this.handleMatchHeight('[data-nosto-element="search"] .product-col-info') 
        this.handleMatchHeight('[data-nosto-element="search"] .product-col-info .product-col-title');
      });
    });

    // Observe the whole body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  matchHeightAutoComplete(){
    const observer = new MutationObserver((mutations, obs) => {
      const el = document.querySelectorAll('[data-nosto-element="autocomplete"]');
      if (el) {
          
        el.forEach(el => {
          this.handleMatchHeight('[data-nosto-element="autocomplete"] .product-col-info')
          this.handleMatchHeight('[data-nosto-element="autocomplete"] .product-col-info .product-col-title')
        });
        //obs.disconnect(); // stop observing once injected
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } 

  bindEventWithAccordion(){
    const checkElement = setInterval(() => {
      if(document.querySelectorAll('.pxg-style-with-bunle .nosto-accordion').length || document.querySelectorAll('.pxg-you-may-also-like .nosto-accordion').length){
        clearInterval(checkElement)
        const accordions = document.querySelectorAll('.nosto-accordion');

        if (accordions.length >= 2) {
          accordions[0].setAttribute('open', 'true');
          accordions[0].classList.add('open');
        } else if (accordions.length === 1) {
          accordions[0].setAttribute('open', 'true');
          accordions[0].classList.add('open');
        }

        document.addEventListener('click', function (e) {
          const btn = e.target.closest('.nosto-accordion button.accordion-btn');
          if (!btn) return;

          const accordion = btn.closest('.nosto-accordion');
          if (!accordion) return;

          // Toggle only this accordion
          accordion.classList.toggle('open');
          if (accordion.classList.contains('open')) {
            accordion.setAttribute('open', 'true');
          } else {
            accordion.removeAttribute('open');
          }
        });

      }
   }, 10);
  }
  
  openQuickView(product, Pid, finalRef) {
      const root = document.getElementById('quick-view-root');
      root.innerHTML = '';
    
    const optionHTML = product.options
    .filter(opt => opt.name !== 'Title' && opt.values?.length)
    .map((opt, idx) => {
      const isColor = opt.name.toLowerCase() === 'color';

    return `
      <div class="qv-option-group" data-opt-name="${opt.name}">
        <legend class="field-label field-label--block flex gap-2 pb-1">
          <span class="text-caps">${opt.name}: </span>
          <span class="qv-selected-value" data-opt-index="${idx}">${opt.values[0]}</span>
        </legend>
        <div class="qv-options-wrap" data-opt-index="${idx}">
          ${opt.values
            .map((value, index) => {
              const colorItem = this.colorMap[value];
              const isImage = typeof colorItem === 'string' && colorItem.startsWith('/');
              
              if (isColor) {
                return `
                  <button
                    key="${index}"
                    type="button"
                    class="qv-option-btn swatch-input__label swatch-input__label--square"
                    data-value="${value}"
                    aria-label="${value}"
                    title="${value}"
                  >
                    <span
                      class="swatch swatch--square"
                      style="${!isImage && colorItem ? `--swatch--background: ${colorItem}` : ''}"
                    >
                      <span class="visually-hidden">${value}</span>
                      ${isImage ? `
                        <picture>
                          <img
                            src="${colorItem}"
                            alt="${value}"
                            width="3000"
                            height="3000"
                            loading="lazy"
                            class="w-full h-full object-cover object-center"
                            decoding="async"
                           />
                        </picture>
                      ` : ''}
                    </span>
                  </button>
                `;
              } else {
                return `
                  <button
                    class="qv-option-btn field-pill"
                    data-value="${value}"
                    type="button"
                    aria-label="${value}"
                    title="${value}"
                  >
                    <span>${value}</span>
                  </button>
                `;
              }
            })
            .join('')}
        </div>
      </div>
    `;
  })
  .join('');

    
      /* ----------------------------------------------------------------
         Initial variant = first available
         ---------------------------------------------------------------- */
      let currentVariant = product.variants.find(v => v.available) || product.variants[0];
      let productUrl = product?.url;

      /* ----------------------------------------------------------------
         Inject modal markup
         ---------------------------------------------------------------- */
      root.innerHTML = `
        <div class="qv-overlay" tabindex="-1" role="dialog" aria-modal="true">
          <div class="qv-modal" role="document">
            <div class="qv-close-bar">
              <button class="qv-close" aria-label="Close quick view">&#10005;</button>
            </div>  
    
            <div class="qv-flex">
              <div class="qv-media">
                <img id="qv-image" src="${this.getVariantImage(currentVariant, product)}"
                     alt="${product.title}" loading="lazy">
              </div>
      
              <div class="qv-info">
                <h2 class="qv-title h3 flex justify-start pb-4 font-semibold md:px-0">${product.title}</h2>
  
                <div class="qv-pricing price price--large">
                  <span class="price--on-sale">
                    <span id="qv-compare" class="qv-compare price-item price-item--regular" hidden></span>
                  </span>
                  <span id="qv-price" class="qv-price price-item"></span>
                </div>
                
                <!-- ⬇️ option selects go here -->
                <div id="qv-options" class="flex flex-col gap-3 product-options">${optionHTML}</div>
      
                <button id="qv-addtocart" class="qv-add button btn-lg btn-primary w-full capitalize">Add to cart</button>
                <a href="${productUrl}" class="qv-link btn-secondary btn-lg btn-primary w-full capitalize">See Full Details</a>
                <p class="qv-error h5 flex justify-start pb-4 text-right font-normal" hidden></p>
              </div>
            </div>
          </div>
        </div>
      `;
    
      /* ----------------------------------------------------------------
         Wire up behaviour
         ---------------------------------------------------------------- */
      const overlay      = root.querySelector('.qv-overlay');
      const addBtn       = root.querySelector('#qv-addtocart');
      const imgEl        = root.querySelector('#qv-image');
      const selects = root.querySelectorAll('.qv-option-btn');
      const errorEl      = root.querySelector('.qv-error');
      const priceEl   = root.querySelector('#qv-price');
      const compareEl = root.querySelector('#qv-compare');
    
      const close = () => { root.innerHTML = ''; document.removeEventListener('keyup', onEsc); };
    
      overlay.addEventListener('click', e => {
        if (e.target === overlay || e.target.classList.contains('qv-close')) close();
      });
      document.addEventListener('keyup', onEsc);
      function onEsc(e) { if (e.key === 'Escape') close(); }
      
      const currencyCode = window.Shopify?.currency?.active;
      let current = this;
     
      async function updateVariant() {
          const chosen = [...root.querySelectorAll('.qv-options-wrap')].map(group => {
          const selected = group.querySelector('.qv-option-btn.selected');
          return selected ? selected.dataset.value : '';
      });
    
      const v = product.variants.find(variant =>
        chosen.every((val, i) => variant[`option${i + 1}`] === val)
      );

      currentVariant = v || null;
      
      if (currentVariant) {
            const currency = current.detectCurrency(product, currentVariant);

            priceEl.textContent = current.formatMoney(currentVariant.price, currency);
        
            const hasDiscount =
              currentVariant.compare_at_price &&
              parseFloat(currentVariant.compare_at_price) > parseFloat(currentVariant.price);
        
            if (hasDiscount) {
              compareEl.textContent = current.formatMoney(currentVariant.compare_at_price, currency);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }

              if(currentVariant?.featured_image){
                 const img = currentVariant?.featured_image?.src;
                  imgEl.src = img;
              }
          }
    
           if (currentVariant && currentVariant.available) {
            addBtn.textContent = "Add to cart";
            addBtn.disabled = false;
           
            errorEl.hidden = true;
          } else {
            addBtn.textContent = "Sold Out";
            addBtn.disabled = true;
            errorEl.textContent = currentVariant ? 'That combination is sold out.' :
                                                   'That combination is sold out.';
            errorEl.hidden = false;
          }
    }

    root.querySelectorAll('.qv-options-wrap').forEach(group => {
        const firstBtn = group.querySelector('.qv-option-btn');
        if (firstBtn) firstBtn.classList.add('selected');
      
        const idx = group.dataset.optIndex;
        const val = firstBtn?.dataset.value || '';
        const label = root.querySelector(`.qv-selected-value[data-opt-index="${idx}"]`);
        if (label) label.textContent = val;
      });

    const optionButtons = root.querySelectorAll('.qv-option-btn');
      optionButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          const idx = btn.closest('.qv-options-wrap').dataset.optIndex;
          const val = btn.dataset.value;
      
          btn.closest('.qv-options-wrap').querySelectorAll('.qv-option-btn').forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
      
          root.querySelector(`.qv-selected-value[data-opt-index="${idx}"]`).textContent = val;
      
          updateVariant();
        });
      });
    
      updateVariant();
      addBtn.addEventListener('click', async () => {
        if (!currentVariant) return;

        addBtn.textContent = "Adding...";
       addBtn.disabled = true;
        
        window.Nosto.addSkuToCart({productId: `${Pid}`, skuId: currentVariant.id}, finalRef).then(async () => {
             const cartRes = await fetch('/cart.js');
             const cartData = await cartRes.json();

             try{
                   if(cartData){
                      const currentCart = this.cart;
                      const finalResponse = cartData?.items?.filter((item) => item.id == currentVariant.id && item.variant_title == currentVariant.title)
              
                      if(finalResponse.length){
                          const res = await fetch(`/cart?sections=cart-drawer,cart-icon-bubble`);
                          const html = await res.json();
                          finalResponse[0].sections = html;
                      }
                    
                       publish(PUB_SUB_EVENTS.cartUpdate, {
                          source: 'product-form',
                          productVariantId: currentVariant.id,
                          cartData: finalResponse[0],
                       });
                       
                       currentCart.renderContents(finalResponse[0]);
                       const spans = document.querySelectorAll('.cart-count-bubble span');
                        window.Nosto.reloadCartWithFlags({skipEvents: true});
                       window.nostojs((api) => {
                         api.resendCartTagging()
                       })   
                   }
                
             } catch(er){
               console.log(er,'oooo')
             }
          }, () => {
             console.log("error message");
          }).finally(() => {
             addBtn.textContent = "Add to cart";
             addBtn.disabled = false;
             close();
          
             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
             
          })
      
      });
    }

    formatMoney(amount, currency = 'USD') {
        // amount may come as a string in dollars ("105.00") or an int in cents (10500)
        const value = typeof amount === 'string' ? parseFloat(amount) : amount / 100;
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value);
      }
      
      detectCurrency(product, variant) {
        return (
          variant?.price_currency ||
          product?.price_currency ||
          window?.Shopify?.currency?.active ||
          window?.ShopifyAnalytics?.meta?.currency ||
          'USD'
        );
      }
    
    getVariantImage(variant, product) {
      if (variant?.image?.src) return variant.image.src;
      return this.getBestImage(product);
    }
    getBestImage(product) {
      if (product.image?.src) return product.image.src;
      if (product.images?.length)     return product.images[0];
      return 'https://cdn.shopify.com/s/files/1/0000/0000/t/0/assets/no-image.png';
    }
  
   addProductwithOptionNosto(){
      document.addEventListener('click', async (e) => {
          const btn = e.target.closest('.multi-item');
        
           if (!btn) return;
            
           e.preventDefault();

          const productImg = btn.closest('.product-img');
          const productUrl = productImg.querySelector('.product-link').getAttribute("href").split("/products")[1];
          const superParent = btn.closest('.product-card');
          const Pid = superParent?.getAttribute('visible-location');
          const refs = btn.closest(".nosto_element");
          const finalRef = JSON.parse(refs.dataset.nostoRef)?.ref;
          
        try {
          const response = await fetch(`/products/${productUrl}.js`, {
              method: 'GET',
              credentials: 'same-origin',
              headers: { 'Accept': 'application/json' },
           });

            const productData = await response.json();
      
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
      
          this.openQuickView(productData, Pid, finalRef);
        } catch (err) {
   
          if (err.name === 'AbortError') {
            console.warn(`[fetchProductJson] Request aborted for ${productUrl}`);
          } else {
            console.error(`[fetchProductJson] Failed for ${productUrl}:`, err);
          }

        }
          
      })
  }
  
  addNostoSingleProductToCart(){
      document.addEventListener('click', (e) => {
            const btn = e.target.closest('.single-item');
        
             if (!btn) return;
            
              e.preventDefault();

              const variantId = btn.dataset.quickItem;
              const superParent = btn.closest('.product-card');
              const Pid = superParent?.getAttribute('visible-location');
              const refs = btn.closest(".nosto_element");
              const finalRef = JSON.parse(refs.dataset.nostoRef)?.ref;
              this.cart.setActiveElement(document.activeElement);

              window.Nosto.addSkuToCart({productId: `${Pid}`, skuId: variantId}, finalRef).then(async () => {
                    const cartRes = await fetch('/cart.js');
                    const cartData = await cartRes.json();
    
                   try{
                         if(cartData){
                            const currentCart = this.cart;
                            const finalResponse = cartData?.items?.filter((item) => item.id == variantId )
                          
                            if(finalResponse.length){
                                const res = await fetch(`/cart?sections=cart-drawer,cart-icon-bubble`);
                                const html = await res.json();
                                finalResponse[0].sections = html;
                            }
                          
                             publish(PUB_SUB_EVENTS.cartUpdate, {
                                source: 'product-form',
                                productVariantId: variantId,
                                cartData: finalResponse[0],
                             });
                             
                             currentCart.renderContents(finalResponse[0]);
                             const spans = document.querySelectorAll('.cart-count-bubble span');
                             window.Nosto.reloadCartWithFlags({skipEvents: true});
                             window.nostojs((api) => {
                               api.resendCartTagging()
                             })
                         }
                      
                   } catch(er){
                     console.log(er,'oooo')
                   }
                }, () => {
                   console.log("error message");
                }).finally(() => {
                   
                   if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                   
                })
      })
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    const isCartPage = cartLink.dataset?.isCart;
    if (isCartPage) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // Run cart validation when drawer opens
    if (window.validateCart) {
      window.validateCart();
    }

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // Dispatch custom event to notify cart updates
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cartData: parsedState },
      }),
    );

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
